//Margin conventions
var margin = {top: 0, right: 40, bottom: 0, left: 142};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 630 - margin.top - margin.bottom;

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.scale.linear()
  .range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
  .rangeBands([height, 0], 0.25)
  .domain(["Environment & energy", "Guns", "Supreme Court", "Obamacare", "Trump scandals", "Trump women", "Trump taxes", "Immigration & refugees", "Clinton scandals", "Race, policing & crime", "ISIS & homeland sec.", "Economy", "Foreign policy"]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(y0)
  .tickSize(-width)
  .tickPadding(4)
  .ticks(4)
  .orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
  .scale(xScale)
  .tickPadding(8)
  .orient("bottom")
  .ticks(6); 

//Loads the data
d3.tsv("data/debate_totals.tsv", ready);

function ready(err, data) {

  if (err) throw "error loading data";
  console.log("hello");

  //FORMAT data
  data.forEach(function(d) {
    d.trump = +d.trump;
    d.clinton = +d.clinton;
  });

  //Sets the max for the xScale
  var maxX = d3.max(data, function(d) { return d.trump; });

  //Defines the xScale max
  xScale.domain([0, maxX ]);

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis); 

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .call(xAxis); 

  //Binds the data to the bars      
  var categoryGroup = svg.selectAll(".g-category-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-category-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.issue) + ")";
    });

  //Appends first bar   
  var bars = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.trump); })
    .attr("height", y0.rangeBand()/2.2 )
    .attr("class", "g-trump")
    .attr("transform", "translate(0,4)");

  //Appends second bar   
  var bars2 = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.clinton); })
    .attr("height", y0.rangeBand()/2.2 )
    .attr("class", "g-clinton")
    .attr("transform", "translate(0,23)");  
  
  //Binds data to labels
  var labelGroup = svg.selectAll(".g-label-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-label-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.issue) + ")";
    });

  //Appends first bar labels   
  var barLabels = labelGroup.append("text") 
    .text(function(d) {return  d.trumpMin;})
    .attr("x", function(d) { return xScale(d.trump) + 4; })
    .attr("y", y0.rangeBand()/2.3 )
    .attr("class", "g-labels");    

  //Appends second bar labels   
  var barLabels2 = labelGroup.append("text") 
    .text(function(d) {return  d.clintonMin;})
    .attr("x", function(d) { return xScale(d.clinton) + 4; })
    .attr("y", y0.rangeBand()/1.05 )
    .attr("class", "g-labels");      

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 0, right: 40, bottom: 0, left: 142};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the bars
    bars
      .attr("width", function(d) { return xScale(d.trump); });

    bars2
      .attr("width", function(d) { return xScale(d.clinton); });  

    //Updates bar labels
    barLabels
      .attr("x", function(d) { return xScale(d.trump) + 4; })
      .attr("y", y0.rangeBand()/2.3 )

    barLabels2
      .attr("x", function(d) { return xScale(d.clinton) + 4; })
      .attr("y", y0.rangeBand()/1.05 )  

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(6);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

  };

}